import { NgModule } from '@angular/core';
import { CustomNavigationEventBuilder } from './custom-navigation-event.builder';

@NgModule({})
export class CustomNavigationEventModule {
  // tslint:disable-next-line:variable-name
  constructor(_customNavigationEventBuilder: CustomNavigationEventBuilder) {}
}
